export const itemMob = [
  {
    title: '首页',
    menuList: [
      {
        secondTitle: '首页',
        url: '/mob'
      }
    ]
  },
  {
    title: '走进大汉',
    menuList: [
      {
        secondTitle: '集团概况',
        url: '/mob/comdetail?index=0',
        name: 'GroupIntroduce',
        index: 0
      },
      {
        secondTitle: '董事长',
        url: '/mob/comdetail?index=1',
        name: 'Leader',
        index: 1
      },
      {
        secondTitle: '价值主张',
        url: '/mob/comdetail?index=2',
        name: 'ShowValue',
        index: 2
      },
      // {
      //   secondTitle: '组织架构',
      //   url: '/mob/comdetail?index=3',
      //   name: 'Origanize',
      //   index: 3
      // },
      {
        secondTitle: '大汉荣誉',
        url: '/mob/comdetail?index=3',
        name: 'ComHonor',
        index: 3
      }
    ]
  },
  {
    title: '新闻中心',
    menuList: [
      {
        secondTitle: '集团新闻',
        url: '/mob/comnews?index=0',
        name: 'GroupNews',
        index: 0
      },
      {
        secondTitle: '媒体视角',
        url: '/mob/comnews?index=1',
        name: 'MediaView',
        index: 1
      },
      // {
      //   secondTitle: '大汉公益',
      //   url: '/mob/comnews?index=2'
      // },
      {
        secondTitle: '多媒体中心',
        url: '/mob/comnews?index=2',
        name: 'MediaCenter',
        index: 2
      }
    ]
  },
  {
    title: '产业布局',
    menuList: [
      {
        url: '/mob/layout',
        secondTitle: '产业布局'
      }
      // {
      //   url: '/mob/introduce',
      //   secondTitle: '公司介绍'
      // }
    ]
  },
  {
    title: '党群文化',
    menuList: [
      {
        secondTitle: '红书包',
        url: '/mob/partyaccess?index=0',
        name: 'RedBag',
        index: 0
      },
      {
        secondTitle: '红管家',
        url: '/mob/partyaccess?index=1',
        name: 'RedAdmin',
        index: 1
      },
      {
        secondTitle: '红青年',
        url: '/mob/partyaccess?index=2',
        name: 'RedYoung',
        index: 2
      },
      {
        secondTitle: '红妈妈',
        url: '/mob/partyaccess?index=3',
        name: 'RedMon',
        index: 3
      },
      {
        secondTitle: '红旗帜',
        url: '/mob/partyaccess?index=4',
        name: 'RedFlag',
        index: 4
      },
      {
        secondTitle: '红春晚',
        url: '/mob/partyaccess?index=5',
        name: 'RedSpring',
        index: 5
      },
      {
        secondTitle: '红展馆',
        url: '/mob/partyaccess?index=6',
        name: 'RedShow',
        index: 6
      }
    ]
  },
  {
    title: '数字大汉',
    menuList: [
      // {
      //   url: '/mob/digitization',
      //   secondTitle: '傅老师说'
      // },
      {
        url: '/mob/digitization',
        secondTitle: '数字化产品'
      }
    ]
  },
  {
    title: '采招平台',
    menuList: [
      {
        secondTitle: '采招平台',
        url: 'https://zhaocai.dahanjsy.com/'
      }
    ]
  },
  {
    title: '人才招聘',
    menuList: [
      {
        secondTitle: '人才招聘',
        url: '/mob/recruitment'
      },
      {
        secondTitle: '校园招聘',
        url: '/mob/school'
      },
      {
        secondTitle: '社会招聘',
        url: 'https://company.zhaopin.com/CZ137478970.htm'
      }
    ]
  },
  {
    title: '廉政建设',
    menuList: [
      {
        secondTitle: '举报入口',
        url: '/mob/online'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/assets/mobJson.js